import Hero from '../components/Hero';
import React from 'react';
import Brands from '../components/Brands';
import HolidaySection from '../components/HolidaySection';
import BestSellers from '../components/BestSellers';
import FeaturedCollection from '../components/FeaturedCollection';
import Testimonials from '../components/Testimonials';
import About from '../components/About';

import { motion } from 'framer-motion';

const Home = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Hero />
            <Brands />
            <HolidaySection />
            <BestSellers />
            <FeaturedCollection />
            <Testimonials />
            <About />
        </motion.div>
    );
};

export default Home;
